export enum SettingsNavigationGroup {
  Channels = "Channels",
  Ticketing = "Ticketing",
  Customization = "Customization",
  Preferences = "Preferences",
  Toolset = "Toolset",
}

export enum BadgeKind {
  On = "on",
  Off = "off",
  Error = "error",
  External = "external",
}
